import { HttpMethodEnum } from "../models/HttpMethodEnum";
import { BaseApi } from "../../utils/BaseApi";
import {
  ConversationAnalyticsConfig,
  ConversationAnalyticsJobAnalysisConfig,
  ConversationAnalyticsJob,
  ConversationAnalyticsOverview,
  ConversationCustomerProfile,
  ConversationServiceAnalysis,
  PaginatedConversationAnalytics,
} from "../models/Analytics/ConversationAnalyticsModels";

export interface CreateConversationAnalyticsJobParams {
  dateFrom: string;
  dateTo: string;
  force?: boolean;
  runNow?: boolean;
  batchSize?: number;
  maxBatches?: number;
  analysisConfig?: Partial<ConversationAnalyticsJobAnalysisConfig>;
}

export interface RunConversationAnalyticsJobParams {
  maxBatches?: number;
}

export interface ConversationAnalyticsRangeParams {
  dateFrom?: string;
  dateTo?: string;
  segment?: string;
  outcome?: string;
  phoneNumber?: string;
  tag?: string;
  frictionType?: string;
  finalOutcome?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export class ConversationAnalyticsApi extends BaseApi {
  private static instance: ConversationAnalyticsApi;

  public static get(): ConversationAnalyticsApi {
    if (!this.instance) {
      this.instance = new ConversationAnalyticsApi();
    }
    return this.instance;
  }

  public config = BaseApi.createEndpoint<ConversationAnalyticsConfig, null>(
    HttpMethodEnum.GET,
    "/analytics/conversations/config"
  );

  public updateConfig = BaseApi.createEndpoint<
    ConversationAnalyticsConfig,
    Partial<ConversationAnalyticsConfig>
  >(HttpMethodEnum.PUT, "/analytics/conversations/config");

  public createJob = BaseApi.createEndpoint<
    ConversationAnalyticsJob,
    CreateConversationAnalyticsJobParams
  >(HttpMethodEnum.POST, "/analytics/conversations/jobs");

  public jobs = BaseApi.createEndpoint<ConversationAnalyticsJob[], null>(
    HttpMethodEnum.GET,
    "/analytics/conversations/jobs"
  );

  public overview = BaseApi.createEndpoint<
    ConversationAnalyticsOverview,
    ConversationAnalyticsRangeParams
  >(HttpMethodEnum.GET, "/analytics/conversations/overview");

  public services = BaseApi.createEndpoint<
    PaginatedConversationAnalytics<ConversationServiceAnalysis>,
    ConversationAnalyticsRangeParams
  >(HttpMethodEnum.GET, "/analytics/conversations/services");

  public customers = BaseApi.createEndpoint<
    PaginatedConversationAnalytics<ConversationCustomerProfile>,
    ConversationAnalyticsRangeParams
  >(HttpMethodEnum.GET, "/analytics/conversations/customers");

  getCustomerTimeline(
    phoneNumber: string,
    params?: { limit?: number; dateFrom?: string; dateTo?: string }
  ) {
    return BaseApi.requestBuilder.requestHard<ConversationServiceAnalysis[]>(
      HttpMethodEnum.GET,
      `/analytics/conversations/customers/${encodeURIComponent(
        phoneNumber
      )}/timeline`,
      params ?? { limit: 100 }
    );
  }

  runJob(jobId: string, params: RunConversationAnalyticsJobParams) {
    return BaseApi.requestBuilder.requestHard<any>(
      HttpMethodEnum.POST,
      `/analytics/conversations/jobs/${jobId}/run`,
      params
    );
  }
}

export const conversationAnalyticsApi = ConversationAnalyticsApi.get();
